export type FavoriteKind = 'vacancy' | 'summary';

/** Favorites of the signed-in client (`/me/favorites`), identified by their target. */
export const useApiFavorite = () => {
    const favoritesCount = useState<number>('favoritesCount', () => 0);
    return {
        /** Returns the favorite id, or null when the request failed. */
        add: async (kind: FavoriteKind, targetId: string): Promise<string | null> => {
            const response = await mainFetch(`me/favorites/${kind}/${targetId}`, { method: 'PUT' });
            if (response.error.value || typeof response.data.value?.favoriteId !== 'string') {
                return null;
            }
            favoritesCount.value += 1;
            return response.data.value.favoriteId;
        },
        delete: async (kind: FavoriteKind, targetId: string): Promise<boolean> => {
            const response = await mainFetch(`me/favorites/${kind}/${targetId}`, { method: 'DELETE' });
            if (response.error.value) {
                return false;
            }
            favoritesCount.value = Math.max(0, favoritesCount.value - 1);
            return true;
        }
    };
}
